import { Grid, Typography } from "@mui/material";
import { connect } from "react-redux";

const IndicadoresLista = (props: any) => {
  // 📌 Extraer el filtro de año desde Redux
  const yearFilter = Array.isArray(props.filters)
    ? props.filters.find((filter: any) => filter.codigo === "year")
    : null;

  const selectedYear = yearFilter?.valor || "No especificado";

  return (
    <Grid container spacing={2} justifyContent="center" style={{ marginTop: "20px" }}>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Typography variant="h4">Hola</Typography>
        <Typography variant="h6" color="textSecondary">
          Año seleccionado: {selectedYear}
        </Typography>
      </Grid>
    </Grid>
  );
};

// 🔗 Conectar Redux para obtener el filtro de año
const mapStateToProps = (state: any) => {
  return { filters: state.filters };
};

export default connect(mapStateToProps)(IndicadoresLista);
